export enum KC_PaddingEnum {
  default = "default",
  even = "even",
  cta = "cta",
  gift = "gift",
  none = "none"
}
